const menuItems = [
  {
    menuTitle: "",
    pageURL: "/",
  },
  {
    menuTitle: "What We Do",
    pageURL: "/what-we-do",
  },
  {
    menuTitle: "About Us",
    pageURL: "/about-us",
  },
  {
    menuTitle: "Subsidiaries",
    pageURL: "/subsidiaries",
  },
  {
    menuTitle: "Media",
    pageURL: "/media",
  },
  {
    menuTitle: "Canary Foundation",
    pageURL: "/canary-foundation",
  },
  {
    menuTitle: "Careers",
    pageURL: "/careers",
  },
];

export default menuItems;
